import {useComponentsTheme} from 'platform/components';
import {Box} from 'platform/foundation';

import {ReactNode} from 'react';

// Less than the side padding: the grid toolbar adds its own inset above the search, so the space
// above the search then matches the space below it.
const BAND_TOP_PADDING = 3;
const BAND_PADDING = 4;

interface JobGridBandProps {
  children: ReactNode;
  /** False renders the children without the band, for a grid that may render nothing. */
  isVisible?: boolean;
}

/**
 * The white band across a job card that holds a grid. It runs down to the bottom card edge, so its
 * bottom corners follow the card radius (T20-142559).
 */
export function JobGridBand(props: JobGridBandProps) {
  const componentsTheme = useComponentsTheme();
  const isVisible = props.isVisible ?? true;

  return (
    <Box
      backgroundColor={isVisible ? 'palettes.white.10.100' : undefined}
      paddingTop={isVisible ? BAND_TOP_PADDING : 0}
      paddingHorizontal={isVisible ? BAND_PADDING : 0}
      paddingBottom={isVisible ? BAND_PADDING : 0}
      borderBottomLeftRadius={componentsTheme.components.Card.borderRadius}
      borderBottomRightRadius={componentsTheme.components.Card.borderRadius}
    >
      {props.children}
    </Box>
  );
}
